import React, { ReactNode } from 'react';

type HotelNamesRowProps = {
  /** NAZWY hoteli (join robi backend w `v3-getUsers`). */
  names?: string[];
};

// Hotele listujemy JEDEN POD DRUGIM, a nie chipami w poziomie — user bywa
// przypisany do kilku i rząd rozpychał tabelę tak, że dalsze kolumny nie
// mieściły się na ekranie. Długie nazwy ucinamy (pełna w `title`).
export const HotelNamesRow = ({ names }: HotelNamesRowProps): ReactNode => {
  const list = (names ?? []).filter(Boolean);

  if (list.length === 0) {
    return <span className="text-gray-400">—</span>;
  }

  return (
    <div className="flex flex-col items-start gap-1">
      {list.map((name) => (
        <span
          key={name}
          title={name}
          className="max-w-full truncate rounded-md bg-gray-100 px-1.5 py-0.5 text-[11px] leading-4 text-gray-700"
        >
          {name}
        </span>
      ))}
    </div>
  );
};
